import { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, DialogActions, DialogContent, FormHelperText, Grid, Input, InputAdornment, OutlinedInput, Paper, Typography } from '@mui/material';
import IconTooltipButton from '../../button/IconTooltipButton';
import isEmpty from 'lodash/isEmpty';
/* 	InputIcon 
 *	@params id 			string	 	identificador input
 *	@params value		any type	value input
 *	@params disabled	bool		disabled input
 *	@params onChange	function 	function change	
 */

 const icons = [
  { name: 'abacus', 	icon: ["fal", "abacus"] },
  { name: 'alarm clock', 	icon: ["fal", "alarm-clock"] },
  { name: 'anchor', 	icon: ["fal", "anchor"] },
  { name: 'apple alt', 	icon: ["fal", "apple-alt"] },
  { name: 'archive', 	icon: ["fal", "archive"] },
  { name: 'atlas', 	icon: ["fal", "atlas"] },
  { name: 'atom', 	icon: ["fal", "atom"] },
  { name: 'award', 	icon: ["fal", "award"] },
  { name: 'baby', 	icon: ["fal", "baby"] },
  { name: 'backpack', 	icon: ["fal", "backpack"] },
  { name: 'bacteria', 	icon: ["fal", "bacteria"] },
  { name: 'bacterium', 	icon: ["fal", "bacterium"] },
  { name: 'badge check', 	icon: ["fal", "badge-check"] },
  { name: 'balance scale', 	icon: ["fal", "balance-scale"] },
  { name: 'balance scale right', 	icon: ["fal", "balance-scale-right"] },
  { name: 'balance scale left', 	icon: ["fal", "balance-scale-left"] },
  { name: 'ball pile', 	icon: ["fal", "ball-pile"] },
  { name: 'ballot', 	icon: ["fal", "ballot"] },
  { name: 'ballot check', 	icon: ["fal", "ballot-check"] },
  { name: 'baseball', 	icon: ["fal", "baseball"] },
  { name: 'baseball ball', 	icon: ["fal", "baseball-ball"] },
  { name: 'batteryfull', 	icon: ["fal", "battery-full"] },
  { name: 'bell', 	icon: ["fal", "bell"] },
  { name: 'bell school', 	icon: ["fal", "bell-school"] },
  { name: 'bells', 	icon: ["fal", "bells"] },
  { name: 'bezier curve', 	icon: ["fal", "bezier-curve"] },
  { name: 'binoculars', 	icon: ["fal", "binoculars"] },
  { name: 'bomb', 	icon: ["fal", "bomb"] },
  { name: 'bong', 	icon: ["fal", "bong"] },
  { name: 'book', 	icon: ["fal", "book"] },
  { name: 'book alt', 	icon: ["fal", "book-alt"] },
  { name: 'bookmark', 	icon: ["fal", "bookmark"] },
  { name: 'books', 	icon: ["fal", "books"] },
  { name: 'box', 	icon: ["fal", "box"] },
  { name: 'box alt', 	icon: ["fal", "box-alt"] },
  { name: 'box ballot', 	icon: ["fal", "box-ballot"] },
  { name: 'box check', 	icon: ["fal", "box-check"] },
  { name: 'boxes', 	icon: ["fal", "boxes"] },
  { name: 'brain', 	icon: ["fal", "brain"] },
  { name: 'bring forward', 	icon: ["fal", "bring-forward"] },
  { name: 'bring front', 	icon: ["fal", "bring-front"] },
  { name: 'brush', 	icon: ["fal", "brush"] },
  { name: 'bug', 	icon: ["fal", "bug"] },
  { name: 'building', 	icon: ["fal", "building"] },
  { name: 'burn', 	icon: ["fal", "burn"] },
  { name: 'business-time', 	icon: ["fal", "business-time"] },
  { name: 'cabinet-filing', 	icon: ["fal", "cabinet-filing"] },
  { name: 'calculator-alt', 	icon: ["fal", "calculator-alt"] },
  { name: 'calendar', 	icon: ["fal", "calendar"] },
  { name: 'camera', 	icon: ["fal", "camera"] },
  { name: 'campfire', 	icon: ["fal", "campfire"] },
  { name: 'capsules', 	icon: ["fal", "capsules"] },
  { name: 'certificate', 	icon: ["fal", "certificate"] },
  { name: 'chart area', 	icon: ["fal", "chart-area"] },
  { name: 'chart line', 	icon: ["fal", "chart-line"] },
  { name: 'child', 	icon: ["fal", "child"] },
  { name: 'clipboard list', 	icon: ["fal", "clipboard-list"] },
  { name: 'clipboard list check', 	icon: ["fal", "clipboard-list-check"] },
  { name: 'clipboard check', 	icon: ["fal", "clipboard-check"] },
  { name: 'code', 	icon: ["fal", "code"] },
  { name: 'code branch', 	icon: ["fal", "code-branch"] },
  { name: 'cog', 	icon: ["fal", "cog"] },
  { name: 'cogs', 	icon: ["fal", "cogs"] },
  { name: 'coin', 	icon: ["fal", "coin"] },
  { name: 'coins', 	icon: ["fal", "coins"] },
  { name: 'comment', 	icon: ["fal", "comment"] },
  { name: 'crop-alt', 	icon: ["fal", "crop-alt"] },
  { name: 'deaf', 	icon: ["fal", "deaf"] },
  { name: 'debug', 	icon: ["fal", "debug"] },
  { name: 'dewpoint', 	icon: ["fal", "dewpoint"] },
  { name: 'dice', 	icon: ["fal", "dice"] },
  { name: 'diploma', 	icon: ["fal", "diploma"] },
  { name: 'donate', 	icon: ["fal", "donate"] },
  { name: 'external link alt', 	icon: ["fal", "external-link-alt"] },
  { name: 'eye', 	icon: ["fal", "eye"] },
  { name: 'fan', 	icon: ["fal", "fan"] },
  { name: 'file', 	icon: ["fal", "file"] },
  { name: 'file certificate', 	icon: ["fal", "file-certificate"] },
  { name: 'fire', 	icon: ["fal", "fire"] },
  { name: 'flag', 	icon: ["fal", "flag"] },
  { name: 'folder', 	icon: ["fal", "folder"] },
  { name: 'function', 	icon: ["fal", "function"] },
  { name: 'futbol', 	icon: ["fal", "futbol"] },
  { name: 'gamepad', 	icon: ["fal", "gamepad"] },
  { name: 'galaxy', 	icon: ["fal", "galaxy"] },
  { name: 'ghost', 	icon: ["fal", "ghost"] },
  { name: 'globe', 	icon: ["fal", "globe"] },
  { name: 'globe americas', 	icon: ["fal", "globe-americas"] },
  { name: 'graduation cap', 	icon: ["fal", "graduation-cap"] },
  { name: 'landmark alt', 	icon: ["fal", "landmark-alt"] },
  { name: 'language', 	icon: ["fal", "language"] },
  { name: 'lightbulb exclamation', 	icon: ["fal", "lightbulb-exclamation"] },
  { name: 'music', 	icon: ["fal", "music"] },
  { name: 'object group', 	icon: ["fal", "object-group"] },
  { name: 'omega', 	icon: ["fal", "omega"] },
  { name: 'palette', 	icon: ["fal", "palette"] },
  { name: 'pencil paintbrush', 	icon: ["fal", "pencil-paintbrush"] },
  { name: 'phone laptop', 	icon: ["fal", "phone-laptop"] },
  { name: 'photo video', 	icon: ["fal", "photo-video"] },
  { name: 'pi', 	icon: ["fal", "pi"] },
  { name: 'running', 	icon: ["fal", "running"] },
  { name: 'school', 	icon: ["fal", "school"] },
  { name: 'scroll old', 	icon: ["fal", "scroll-old"] },
  { name: 'shapes', 	icon: ["fal", "shapes"] },
  { name: 'shield', 	icon: ["fal", "shield"] },
  { name: 'shield check', 	icon: ["fal", "shield-check"] },
  { name: 'sliders h', 	icon: ["fal", "sliders-h"] },
  { name: 'sliders v', 	icon: ["fal", "sliders-v"] },
  { name: 'square root alt', 	icon: ["fal", "square-root-alt"] },
  { name: 'star', 	icon: ["fal", "star"] },
  { name: 'theater masks', 	icon: ["fal", "theater-masks"] },
  { name: 'tint', 	icon: ["fal", "tint"] },
  { name: 'user friends', 	icon: ["fal", "user-friends"] },
  { name: 'wifi', 	icon: ["fal", "wifi"] },
  { name: 'wifi-slash', 	icon: ["fal", "wifi-slash"] },
]

const InputIcon = ({ id, value, onChange, disabled, error }) => {
  const [showIcons, setShowIcons] = useState(false)
  const [options, setOptions] = useState(icons)
  const [icon, setIcon] = useState(value  || '')

  useEffect(() => {
    setIcon(value || '')
  }, [value])

  const onChangeSearch = (e) => {
    const search = e.target.value.toLowerCase()
    const filteredOptions = icons.filter(item => item.name.toLowerCase().includes(search))
    setOptions(filteredOptions)
  }

  return (
    <>
      <Button
        key={`icon-${id}`} 
        size='small'
        variant='text'
        disabled={disabled}
        onClick={disabled ?  undefined: () => setShowIcons(!showIcons)}
        style={{
          padding: '0.5rem',
          minWidth: '2.5rem',
        }}
      >
        {isEmpty(icon) === false 
          ? <FontAwesomeIcon className='text-3xl' icon={icon} />
          : <span>Select an icon</span>
        }
      </Button>
      { error &&
        <FormHelperText error={!!error}>
          {error}
        </FormHelperText>
      }
      { showIcons &&
        <Dialog
          open={showIcons}
          maxWidth='xs'
          fullWidth
          style={{ backgroundColor: 'transparent' }}
        >
          <DialogContent dividers={true} className='flex flex-col gap-4'>
            <div className='sticky top-0 bg-background z-10'>
              <OutlinedInput
                id="outlined-adornment-password"
                fullWidth
                className=' bg-background'
                onChange={onChangeSearch}
                endAdornment={
                  <InputAdornment position="end">
                    <IconTooltipButton
                      title="toggle password visibility"
                      icon='search'
                    />
                  </InputAdornment>
                }
              />
            </div>
            <div className='grid grid-cols-6 gap-2 h-screen-1/3 overflow-auto items-start'>
              { options.length === 0 &&
                <Typography className='text-muted-foreground opacity-50 w-full col-span-full'>No results found</Typography>
              }
              { options.map((item, index) => (
                  <Button
                    key={`icon-${id}-${index}`} 
                    size='small'
                    variant={JSON.stringify(icon) === JSON.stringify(item.icon) ? 'contained' : 'text'}
                    color={JSON.stringify(icon) === JSON.stringify(item.icon) ? 'primary' : 'inherit'}
                    onClick={() => setIcon(item.icon)}
                    style={{
                      padding: '0.5rem',
                      minWidth: '2.5rem',
                    }}
                  >
                    <div className='flex flex-col pt-2 text-ellipsis overflow-hidden '>
                      <FontAwesomeIcon className='text-3xl' icon={item.icon} />
                      <p className='text-nowrap initial-case text-center text-xs'>{item.name}</p> 
                    </div>
                  </Button>
              ))}
            </div>
          </DialogContent>
          <DialogActions>
            <IconTooltipButton
              title="Cancel"
              icon="times"
              onClick={() => setShowIcons(false)}
            />
            <IconTooltipButton
              color="primary"
              title="Apply"
              icon="check"
              onClick={() => {
                onChange(icon)
                setShowIcons(false)
              }}
            />
          </DialogActions>
        </Dialog>
      }
    </>
  )
}
    
export default InputIcon